import { MAINTAB } from "../_constants/actionConstants";

const tabsInitialState = {
  selectedTabId: 0,
  tabSelectionHistory: [],
  reservedTabIds: {}, // A key-value pair, where key = UUID to be reserved, and value = tabId
  openTabs: [
    {
      tabId: 0,
      label: "Home",
      link: "#",
      docType: "HOME",
      projectId: null,
      docId: null, // Only where applicable (e.g. adrId)
      searchId: null, // Only used for search result tabs
      contentIsModified: false,
    },
  ],
};

export const reducer = (state = tabsInitialState, action) => {
  switch (action.type) {
    case MAINTAB.ADD:
      return { ...state, openTabs: [...state.openTabs, action.tab] };

    case MAINTAB.SELECT:
      if (action.tabId === NaN || action.tabId === undefined || action.tabId === null)
        return { ...state, selectedTabId: 0 };
      return { ...state, selectedTabId: action.tabId };

    case MAINTAB.CLOSE:
      if (!action.tab) return { ...state };
      return {
        ...state,
        openTabs: state.openTabs.filter((t) => t.tabId !== action.tab.tabId),
      };

    case MAINTAB.CLOSE_ALL:
      return tabsInitialState;

    case MAINTAB.MARK_DIRTY:
      const modifiedTabIndex = state.openTabs.findIndex(
        (tab) => tab.tabId === action.tabId
      );
      const modifiedOpenTabs = [...state.openTabs];
      modifiedOpenTabs[modifiedTabIndex].contentIsModified = true;
      return { ...state, openTabs: modifiedOpenTabs };

    case MAINTAB.UNMARK_DIRTY:
      const tabIndex = state.openTabs.findIndex((tab) => tab.tabId === action.tabId);
      const openTabs = [...state.openTabs];
      openTabs[tabIndex].contentIsModified = false;
      return { ...state, openTabs };

    case MAINTAB.CHANGE_LABEL: {
      let openTabs = state.openTabs.map((t) => ({ ...t }));
      const tab = openTabs.find((t) => t.tabId === action.tabId);
      if (tab) {
        tab.label = action.newLabel;
        return { ...state, openTabs };
      }
      return { ...state };
    }

    case MAINTAB.CHANGE_METADATA: {
      let openTabs = state.openTabs.map((t) => ({ ...t }));
      const tab = openTabs.find((t) => t.tabId === action.tabId);
      if (tab && action.tabData) {
        for (const key in action.tabData) {
          if (key !== "metadata") tab[key] = action.tabData[key];
          else tab[key] = { ...tab[key], ...action.tabData[key] };
        }
      }
      return { ...state, openTabs };
    }

    case MAINTAB.RESERVE_TAB_ID:
      if (!action.idCheckoutToken) return { ...state, ...reservedTabIds };
      return {
        ...state,
        reservedTabIds: {
          ...state.reservedTabIds,
          [action.idCheckoutToken]: action.tabId,
        },
      };

    case MAINTAB.UNRESERVE_TAB_ID:
    case MAINTAB.APPLY_TAB_ID:
      if (!action.idCheckoutToken) return { ...state, ...reservedTabIds };
      let reservedTabIds = { ...state.reservedTabIds };
      delete reservedTabIds[action.idCheckoutToken];
      return {
        ...state,
        reservedTabIds,
      };

    default:
      return state;
  }
};
